<div class="search-input-container" [class.fixed-width]="fixedWidth">
  <button
    *ngIf="leftIconAction"
    class="action-button left-action"
    [disabled]="isSendingMessage"
    [ngClass]="{ 'empty': isSendingMessage, 'black-background': showBlackButtons }"
    (click)="executeLeftIconAction()">
    <img src="assets/img/attach-photo.svg" />
  </button>

  <div class="search-icon" *ngIf="!leftIconAction">
    <tidy-image [src]="icon"></tidy-image>
  </div>

  <textarea
    #inputElement
    class="search-input"
    [ngModel]="value"
    (ngModelChange)="onInputChange($event)"
    [placeholder]="placeholder | translate"
    (keydown)="onKeyDown($event)"
    rows="1"
    [style.height]="'auto'"
    [style.height.px]="inputElement.scrollHeight"
  ></textarea>

  <button
    *ngIf="rightIconAction"
    class="action-button right-action"
    [disabled]="isSendingMessage || isInputEmpty"
    [ngClass]="{ 'empty': isInputEmpty || isSendingMessage, 'black-background': showBlackButtons }"
    (click)="executeRightIconAction()">
    <img src="assets/img/send-message.svg" />
  </button>

  <button
    *ngIf="!rightIconAction && !isInputEmpty"
    class="clear-button"
    (click)="clearInput()">
    <mat-icon>close</mat-icon>
  </button>
</div>
